const routes = [{
  path: '*',
  name: 'all',
  redirect: '/'
}, {
  path: '/',
  component: () => import('./views/0-Main.vue')
}]

export default routes;